<div class="fund-name-modal">
  <div class="fund-name-modal__header">
    <div class="fund-name-modal__header-content">
      <h2 class="fund-name-modal__title">Select Fund Name</h2>
      <p class="fund-name-modal__subtitle">
        Select the fund name for this due diligence launch.
      </p>
    </div>
    <button type="button" class="fund-name-modal__close" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="fund-name-modal__content">
    <div class="fund-name-modal__status" *ngIf="isFundNameSuggestionsLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading AI fund names...</span>
    </div>

    <div class="fund-name-option-list">
      <div
        *ngFor="let option of fundNameOptions"
        class="fund-name-option"
        [class.fund-name-option--selected]="selectedFundName === option.name"
        (click)="selectFundName(option)"
      >
        <div class="fund-name-option__selection">
          <input
            type="radio"
            name="sharedDdFundName"
            class="fund-name-option__radio-input"
            [checked]="selectedFundName === option.name"
            (change)="selectFundName(option)"
            (click)="$event.stopPropagation()"
          />
          <span class="fund-name-option__radio"></span>
        </div>

        <div class="fund-name-option__body">
          <div *ngIf="!option.isEditing" class="fund-name-option__name" [matTooltip]="getFundNameSourceTooltip(option)">
            {{ option.name }}
          </div>

          <input
            *ngIf="option.isEditing"
            [(ngModel)]="option.name"
            (click)="$event.stopPropagation()"
            (keydown.enter)="saveFundNameEdit(option)"
            (blur)="saveFundNameEdit(option)"
            class="fund-name-option__input"
            placeholder="Enter fund name"
          />
        </div>

        <button
          type="button"
          class="fund-name-option__edit"
          [class.fund-name-option__edit--active]="option.isEditing"
          (mousedown)="handleFundNameAction(option, $event)"
          [matTooltip]="option.isEditing ? 'Save fund name' : 'Edit fund name'"
        >
          <mat-icon>{{ option.isEditing ? 'check' : 'edit' }}</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="fund-name-modal__actions">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="isFundNameSuggestionsLoading || !selectedFundName?.trim()"
      (click)="confirm()"
    >
      Continue
    </button>
  </mat-dialog-actions>
</div>
